import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";

import Routes from "./routes"
import Loader from "./components/ui/overlay"
import Toast from "./components/ui/toast";

import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { useNavigate } from "react-router-dom";
import ReactProgressBar from "./components/reactProgressBar";
function App(props) {
    const navigate = useNavigate()
    const loading = useSelector((state) => state.Notification.loading);
    const loadingBar = useSelector((state) => state.loaderBar.loading);


    return (
        <div className="App">
                <Routes />
                <Toast />
                {loading ? <ReactProgressBar loading={loading} /> : null}
                {/* <ReactProgressBar loading={loadingBar} /> */}
            </div>
    );
}

const mapStateToProps = (state) => {
    return {
        notification: state.Notification,
    }
}

const mapDispatchToProps = {  }

export default connect(mapStateToProps, mapDispatchToProps)(App);